// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabbed-view {
  --content-padding: 1rem;
  --icon-size: 2rem;
  --label-size: 3.5rem;
  --label-margin-left: 1rem;
  display: grid;
  grid-template-columns: min-content auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.tabbed-view .tabbed-control {
  display: grid;
  grid-column: 1;
  grid-row: 1;
  height: 100%;
}
.tabbed-view .tabbed-content {
  grid-column: 2;
  grid-row: 1;
  padding: var(--content-padding);
  height: calc(100% - 2 * var(--content-padding));
  overflow-y: scroll;
}
.tabbed-view .tabbed-label {
  background-color: var(--color-base-canvas);
  border-top: solid var(--border-width) var(--color-elevated-border);
  border-right: solid var(--border-width) var(--color-elevated-border);
  border-bottom: none;
  border-left: solid var(--border-width) var(--color-elevated-border);
  box-shadow: calc(-1 * var(--border-width)) 0 0 0 var(--color-base-border);
  height: unset;
  margin: 0 0 0 var(--label-margin-left);
  width: var(--label-size);
}
.tabbed-view .tabbed-label:first-child {
  border-top: none;
}
.tabbed-view .tabbed-label:not(:first-child) {
  margin-top: calc(-1 * var(--border-width));
}
.tabbed-view .tabbed-label:last-child {
  border-bottom: none;
}
.tabbed-view .tabbed-label.active {
  box-shadow: none;
  background-color: var(--color-elevated-canvas);
  border-left-color: var(--color-elevated-canvas);
}
.tabbed-view .tabbed-label.active svg.icon > svg {
  opacity: 1;
}
.tabbed-view .tabbed-label.inactive svg.icon > svg {
  opacity: var(--opacity-inactive);
}
.tabbed-view .tabbed-label:disabled, .tabbed-view .tabbed-label:hover {
  opacity: 1;
}
.tabbed-view .tabbed-label:hover {
  background-color: var(--color-elevated-canvas);
}
.tabbed-view .tabbed-label svg.icon > svg {
  height: var(--icon-size);
  opacity: var(--opacity-inactive);
}
.tabbed-view .tabbed-label .tabbed-label-text {
  display: none;
}

@media only screen and (max-width: 600px) {
  .tabbed-view {
    --label-margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/views/tabbed.scss"],"names":[],"mappings":"AACA;EACE,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EAEA,aAAA;EACA,uCAAA;EACA,kBAAA;EAAoB,MAAA;EAAQ,QAAA;EAAU,SAAA;EAAW,OAAA;AAGnD;AADE;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAGJ;AAAE;EACE,cAAA;EACA,WAAA;EACA,+BAAA;EACA,+CAAA;EACA,kBAAA;AAEJ;AACE;EACE,0CAAA;EACA,kEAAA;EACA,oEAAA;EACA,mBAAA;EACA,mEAAA;EACA,yEAAA;EAEA,aAAA;EACA,sCAAA;EACA,wBAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,0CAAA;AADN;AAII;EACE,mBAAA;AAFN;AAKI;EACE,gBAAA;EACA,8CAAA;EACA,+CAAA;AAHN;AAKM;EACE,UAAA;AAHR;AAQM;EACE,gCAAA;AANR;AAUI;EACE,UAAA;AARN;AAWI;EACE,8CAAA;AATN;AAYI;EACE,wBAAA;EACA,gCAAA;AAVN;AAaI;EACE,aAAA;AAXN;;AAgBA;EACE;IACE,sBAAA;EAbF;AACF","sourcesContent":["\n.tabbed-view {\n  --content-padding: 1rem;\n  --icon-size: 2rem;\n  --label-size: 3.5rem;\n  --label-margin-left: 1rem;\n\n  display: grid;\n  grid-template-columns: min-content auto;\n  position: absolute; top: 0; right: 0; bottom: 0; left: 0;\n\n  .tabbed-control {\n    display: grid;\n    grid-column: 1;\n    grid-row: 1;\n    height: 100%;\n  }\n\n  .tabbed-content {\n    grid-column: 2;\n    grid-row: 1;\n    padding: var(--content-padding);\n    height: calc(100% - calc(2 * var(--content-padding)));\n    overflow-y: scroll;\n  }\n\n  .tabbed-label {\n    background-color: var(--color-base-canvas);\n    border-top: solid var(--border-width) var(--color-elevated-border);\n    border-right: solid var(--border-width) var(--color-elevated-border);\n    border-bottom: none;\n    border-left: solid var(--border-width) var(--color-elevated-border);\n    box-shadow: calc(-1 * var(--border-width)) 0 0 0 var(--color-base-border);\n\n    height: unset;\n    margin: 0 0 0 var(--label-margin-left);\n    width: var(--label-size);\n\n    &:first-child {\n      border-top: none;\n    }\n\n    &:not(:first-child) {\n      margin-top: calc(-1 * var(--border-width));\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &.active {\n      box-shadow: none;\n      background-color: var(--color-elevated-canvas);\n      border-left-color: var(--color-elevated-canvas);\n\n      svg.icon > svg {\n        opacity: 1;\n      }\n    }\n\n    &.inactive {\n      svg.icon > svg {\n        opacity: var(--opacity-inactive);\n      }\n    }\n\n    &:disabled, &:hover {\n      opacity: 1;\n    }\n\n    &:hover {\n      background-color: var(--color-elevated-canvas);\n    }\n\n    svg.icon > svg {\n      height: var(--icon-size);\n      opacity: var(--opacity-inactive);\n    }\n\n    .tabbed-label-text {\n      display: none;\n    }\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .tabbed-view {\n    --label-margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
